module.exports = __webpack_public_path__ + "media/images/gradient-blue-background-524e7a26bebf93bc5721855bb6b1c145.jpg";